export const TagDataFragment = `
    id
    name
    descriptor
    owning_organization_id
`
